import React from "react";
import { SnippetSource } from "./SnippetSource";
import { Loading } from "../../components/Loading";
import { SnippetSourceList } from "./style/styledComponents";
import styled from "styled-components";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

export const SnipptSourceList = ({
  reports,
  loadingReports,
  loadingMoreReports,
  saveSnippet,
  article,
  setIframeSource,
  setOpenSourceMordal,
  saveSnippets,
}) => {
  if (loadingReports) {
    return <Loading />;
  }

  return (
    <SnippetSourceList>
      {reports && reports.reports.length ? (
        reports.reports.map((report, index) => (
          <SnippetSource
            key={index}
            sourceID={index}
            title={report.headline}
            url={report.url}
            snippets={report.snippets}
            source={report.source}
            sourceDate={report.date}
            saveSnippet={saveSnippet}
            article={article}
            setIframeSource={setIframeSource}
            setOpenSourceMordal={setOpenSourceMordal}
            saveSnippets={saveSnippets}
            reportPic={report.topimage}
          />
        ))
      ) : (
        <EmptySource>
          <ErrorOutlineIcon />
          <p>Keine Suchtreffer</p>
        </EmptySource>
      )}
      {loadingMoreReports && <Loading />}
    </SnippetSourceList>
  );
};

export const EmptySource = styled.div`
  color: #ccc !important;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
`;
